import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useWindowWidth } from "@react-hook/window-size";
import ExpireBadge from "components/expireBadge/ExpireBadge";
import PurchaseDropDown from "components/purchaseDropDown/PurchaseDropDown";
import WhoisButton from "components/whoisButton/WhoisButton";
import moment from "moment";
import { memo, useState } from "react";
import { Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import styled from "styled-components";

const Wrapper = styled.div<{ $hasBorder: boolean; $registered: boolean }>`
  min-height: 72px;
  border-bottom: ${(props: any) =>
    props.$hasBorder ? "solid 1px #e8e8ef" : null};
  display: flex;
  padding: 17px 22px;
  align-items: center;
  > svg {
    color: ${(props: any) => (props.$registered ? "#c60404" : "#28c604")};
    margin-top: 4px;
    margin-right: 10px;
  }

  @media only screen and (max-width: 576px) {
    padding-left: 0;
    padding-right: 0;
  }
`;

const StyledDomainLink = styled(Link)<{
  $registered: boolean;
  $loaded: boolean;
}>`
  text-decoration: none;
  font-weight: 500;
  flex: 1;
  display: flex;
  color: ${(props: any) =>
    props.$loaded
      ? props.$registered
        ? "#c60404"
        : "#21b400"
      : "#222222"} !important;
  &:hover {
    text-decoration: underline;
  }
`;

const SpinnerWrapper = styled.div`
  color: #28c604;
  margin-right: 8px;
  margin-left: -2px;
`;

interface DomainResultProps {
  drawSpacer?: boolean;
  resellers?: Array<string> | undefined;
  loading?: boolean;
  expiresOn: string | Date | undefined;
  name: string;
  records?: Array<string> | undefined;
  className?: string | undefined;
}

const DomainResult = (props: DomainResultProps) => {
  const {
    name,
    expiresOn,
    drawSpacer = false,
    loading = false,
    records,
    resellers,
    className,
  } = props;

  const [loadedRecords, setLoadedRecords] = useState<string[] | undefined>();

  const onlyWidth = useWindowWidth();

  const expirationDate = expiresOn ? moment(expiresOn).toDate() : undefined;

  const registered = expirationDate !== undefined;

  const handleRecordsLoaded = (records: string[]) => {
    setLoadedRecords(records);
  };

  return (
    <>
      <Wrapper
        $hasBorder={drawSpacer}
        $registered={registered}
        className={className}
      >
        {loading === true && (
          <SpinnerWrapper>
            <Spinner size="sm" />
          </SpinnerWrapper>
        )}
        {loading === false && (
          <FontAwesomeIcon icon={registered ? faXmark : faCheck} />
        )}
        <StyledDomainLink
          $registered={registered}
          $loaded={loading === false && registered !== undefined}
          to={`/domain/${name}`}
        >
          {name}
        </StyledDomainLink>
        <ExpireBadge
          expirationDate={expiresOn ? moment(expiresOn).toDate() : undefined}
          collapsedView={onlyWidth <= 380}
        />
        {!loading && registered && (
          <WhoisButton
            name={name}
            records={records ?? loadedRecords}
            onRecordsLoaded={handleRecordsLoaded}
          />
        )}
        {!loading && !registered && resellers && (
          <PurchaseDropDown resellers={resellers} domain={name} />
        )}
      </Wrapper>
    </>
  );
};

export default memo(DomainResult);
